import { render, staticRenderFns } from "./CloseThick.vue?vue&type=template&id=6ff70010"
import script from "./CloseThick.vue?vue&type=script&lang=js"
export * from "./CloseThick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports